import { mapMutations } from "vuex";

export default {
	name	: "course-blades-buttons",
	data() {
		return {
			showBtn: false,
		}
	},
	props	: {
		item: {
			type: Object,
		},
		centered: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		lastUserLessonSlug() {
			return this.item.userCourse.data.hasOwnProperty("currentMaterial")
				? this.item.userCourse.data.currentMaterial.data.hasOwnProperty("id")
					? this.item.userCourse.data.currentMaterial.data.slug
					: null
				: null;
		},
		lastUserModuleSlug() {
			return this.item.userCourse.data.hasOwnProperty("currentMaterial")
				? this.item.userCourse.data.currentMaterial.data.hasOwnProperty("id")
					? this.item.userCourse.data.currentMaterial.data.module.data.slug
					: null
				: null;
		},
		nextActiveMaterial() {
			let index = 0,
				list = [],
				activeMaterial = null;
			
			this.item.modules.data.forEach((module) => {
				module.materials.data.forEach((el) => {
					list.push(
						Object.assign(el, {
							moduleSlug: module.slug,
						})
					);
				});
			});
			
			for (let i = index + 1; i < list.length; i++) {
				let item = list[i];
				let typeMaterial =
					item.material === "lesson" ? "userLesson" : "userHomeWork";
				let status = item[typeMaterial].data.hasOwnProperty("id")
					? item[typeMaterial].data.status
					: "new";
				
				if (status !== "failed" && status !== "locked") {
					activeMaterial = item;
					break;
				}
			}
			
			return activeMaterial;
		},
	},
	mounted() {
		this.checkShowBtn();
	},
	watch: {},
	methods	: {
		...mapMutations({
			changePopup	: "popups/CHANGE_POPUP_TRAILER",
			currentItem	: "courses/currentItem",
		}),
		routeToCourseMaterial(material) {
			let type = material.material;
			
			if (type === "lesson") {
				this.$router.push({
					name: "courses-lesson-detail",
					params: {
						item: this.$route.params.item,
						moduleSlug: this.lastUserModuleSlug,
						lessonSlug: this.lastUserLessonSlug,
					},
				});
			} else if (type === "home_work") {
				this.$router.push({
					name: "home-work-rules",
					params: {
						item: this.$route.params.item,
						moduleSlug: this.lastUserModuleSlug,
						testId: this.lastUserLessonSlug,
					},
				});
			} else if (type === "graduate_work") {
				this.$router.push({
					name: "graduate-work-rules",
					params: {
						item: this.$route.params.item,
						moduleSlug: this.lastUserModuleSlug,
						testId: this.lastUserLessonSlug,
					},
				});
			}
		},
		changeBtnStart() {
			let currentMaterial = this.item.userCourse.data.currentMaterial.data;
			
			//return;
			
			switch (this.item.userCourse.data.status) {
				case "new":
					if (this.item.userCourse.data.currentMaterial.data.id) {
						this.routeToCourseMaterial(currentMaterial);
					} else {
						document.location = `#course-description`;
						// this.routeToCourseMaterial(this.nextActiveMaterial);
					}
					
				break;
				case "processing":
					this.routeToCourseMaterial(currentMaterial);
					
				break;
				case "completed":
					// if (this.nextActiveMaterial?.userHomeWork.data?.status !== 'expired') {
					//this.routeToCourseMaterial(this.nextActiveMaterial);
					// } else {
					//   document.location=`#course-description`
					// }
					
				break;
			}
		},
		changeBtnNext(){
			const items = document.querySelectorAll('ul.courses-dashboard_modules-list li[data-status]');
			
			if(!items.length){
				return;
			}
			
			const firstLocked = Array.from(items).find(el => el.dataset.status === 'locked');
			
			if (firstLocked) {
				firstLocked.scrollIntoView({
					behavior: 'smooth',
					block	: 'center'
				});
			}
		},
		checkShowBtn(){
			this.$nextTick(() => {
				const items = document.querySelectorAll('ul.courses-dashboard_modules-list li[data-status]');
				
				if(!items.length){
					this.showBtn = false;
					
					return;
				}
				
				const notLocked = Array.from(items).some(el => el.dataset.status !== 'locked');
				const allLocked = Array.from(items).some(el => el.dataset.status === 'locked');
				
				if((notLocked && allLocked) || (!notLocked && allLocked)){
					this.showBtn = true;
					
					return;
				}
				
				this.showBtn = false;
			});
		},
		changePopupTrailer() {
			this.$bus.$emit("event-open-trailer");
		},
		scrollToLesson(lessonId) {
			this.$nextTick(() => {
				const target = this.$refs['lesson_' + lessonId];
				
				if (target && target[0]) {
					target[0].scrollIntoView({
						behavior: 'smooth',
						block	: 'center'
					});
				}
			});
		},
		scrollToFirstWithStatus(status) {
			const targetLesson = this.item.materials.data.find(
				lesson => this.setStatusMaterialItem(lesson) === status
			);
			
			if (targetLesson) {
				this.scrollToLesson(targetLesson.id);
			}
		}
	},
};
